/* @flow */
import * as React from 'react';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';
import Button from 'components/Button.jsx';
import Confetti from 'components/Confetti.jsx';
import { withRouter } from 'app/context/Router.jsx';
import WizardHeader from 'components/WizardHeader.jsx';
import IntegrationWizardHeaderContent from 'admin/components/IntegrationWizardHeaderContent.jsx';

import './styles/ACISuccess.scss';

type Props = {
  name: string,
  router: any,
  iconURL: string,
};

class ACISuccess extends React.Component<Props, {}> {
  goBack = () => this.props.router.goBack();

  render() {
    return (
      <div className="ACISuccess">
        <Confetti />
        <WizardHeader>
          <IntegrationWizardHeaderContent title={this.props.name} iconURL={this.props.iconURL} />
        </WizardHeader>
        <div className="ACISuccess-content">
          <div>
            <Row>
              <Text className="ACISuccess-content-title" size="xxlarge" element="div">
                All set! {this.props.name} is now set up.
              </Text>
            </Row>
            <Button onClick={this.goBack}>Go to Integrated apps</Button>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(ACISuccess);
